/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const taxVerificationStatusSchema = z.enum(['pending', 'unavailable', 'unverified', 'verified'])

export type TaxVerificationStatusSchema = z.infer<typeof taxVerificationStatusSchema>
